module.exports = __webpack_public_path__ + "img/logo.d2e9979b.svg";